import { render } from "./CovidStatus.vue?vue&type=template&id=6cd3c1b4"
import script from "./CovidStatus.vue?vue&type=script&lang=js"
export * from "./CovidStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__